var map = {
	"./1-1.jpg": "f2d6",
	"./1-2.jpg": "536e",
	"./2-1.jpg": "2972",
	"./2-2.jpg": "e5cb",
	"./3-1.jpg": "c83f",
	"./3-2.jpg": "2c18",
	"./4-1.jpg": "a1b7",
	"./4-2.jpg": "93c4",
	"./5-1.jpg": "1b99",
	"./5-2.jpg": "6922",
	"./6-1.jpg": "916f",
	"./6-2.jpg": "cb08",
	"./big/2-1.jpg": "5ace",
	"./big/cm.jpg": "fdf9",
	"./big/juggernaut.jpg": "fbda",
	"./big/lc.jpg": "02b8",
	"./big/lina.jpg": "33d0",
	"./big/monkey-king.jpg": "1c16",
	"./big/ogre.jpg": "5c11",
	"./big/phantom-assasin.jpg": "45c3",
	"./big/pudge.jpg": "0103",
	"./big/rubick.jpg": "7994",
	"./big/sf.jpg": "545d",
	"./big/techies.jpg": "c05d",
	"./big/terror-blade.jpg": "9fde",
	"./big/zeus.jpg": "3aed",
	"./cm.png": "c717",
	"./juggernaut.png": "a948",
	"./lc.png": "1053",
	"./lina.png": "82d40",
	"./monkey-king.png": "33f5",
	"./ogre.png": "80e3",
	"./phantom-assasin.png": "35a6",
	"./pudge.png": "180a",
	"./rubick.png": "c4df",
	"./sf.png": "cc4f",
	"./techies.png": "4671",
	"./terror-blade.png": "e13a",
	"./zeus.png": "cda2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "44a8";